import { cn } from '../../lib/cn';

/**
 * Ô giữ chỗ lúc đang tải (§9.3.8).
 * Kích thước do phía gọi truyền qua `className`, ví dụ `h-4 w-32`.
 */
export function Skeleton({ className }: { className?: string }) {
  return <div aria-hidden className={cn('animate-pulse rounded bg-subtle', className)} />;
}
